import getStore from '../store/store';
import { mutator } from 'satcheljs';
import { updateTxpFlagV2 } from '../actions/txpOptionsActions';

/**
 * The action to update the flags behind the checkboxes in the txp options UI
 */
export default mutator(updateTxpFlagV2, actionMessage => {
    const optionState = getStore();
    if (actionMessage.flagName == 'CreateEventsFromEmailAsPrivate') {
        optionState[actionMessage.flagName] = actionMessage.enabled;
    } else if (actionMessage.flagName) {
        optionState.EntityTypeProcessorLevelSettings[actionMessage.flagName] = actionMessage.value;
    }
});
